import type { ComponentType } from "react";

import { Badge } from "@similarweb/ui-components";

import { UpdatedBadge } from "app/pages/sales-intelligence/common-components/badge/UpdatedBadge";
import type SignalLifecycleState from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalLifecycleState";

const BadgeNewComponent = () => <Badge type="new" />;
const ComingSoonBadge = () => <Badge type="coming soon" />;

export const deriveSignalTypeBadge = (lifecycleState: SignalLifecycleState | undefined): ComponentType | undefined => {
    switch (lifecycleState) {
        case "coming-soon":
            return ComingSoonBadge;
        case "updated":
            return UpdatedBadge;
        case "post-beta":
            return BadgeNewComponent;
        case "locked":
            return;
        default:
            return;
    }
};
